import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f9a2e9c4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=f9a2e9c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a2e9c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9a2e9c4')) {
      api.createRecord('f9a2e9c4', component.options)
    } else {
      api.reload('f9a2e9c4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f9a2e9c4&scoped=true&", function () {
      api.rerender('f9a2e9c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/developer/index.vue"
export default component.exports